import theme from 'config/theme';
import { AGENT_ROLES, BOOKING_LABELS, CONTRACT_TYPES } from '@constants';

export const BOOKINGS_STAGES = {
  27: {
    label: 'Prelead',
    styles: {
      backgroundColor: theme.palette.grays.gray300,
      color: theme.palette.grays.gray900,
    },
  },
  28: {
    label: 'Hot Prelead',
    styles: {
      backgroundColor: theme.palette.mints.mint200,
      color: theme.palette.mints.mint900,
    },
  },
  0: {
    label: 'Lead In',
    styles: {
      backgroundColor: theme.palette.oranges.orange200,
      color: theme.palette.oranges.orange900,
    },
  },
  29: {
    label: 'No Answer',
    styles: {
      backgroundColor: theme.palette.violets.violet200,
      color: theme.palette.violets.violet900,
    },
  },
  30: {
    label: '2nd Call Attempt',
    styles: {
      backgroundColor: theme.palette.grays.gray400,
      color: theme.palette.grays.gray900,
    },
  },
  31: {
    label: 'Tel Contact No1',
    styles: {
      backgroundColor: theme.palette.grays.gray200,
      color: theme.palette.grays.gray900,
    },
  },
  32: {
    label: 'Follow Up',
    styles: {
      backgroundColor: theme.palette.purples.purple200,
      color: theme.palette.purples.purple900,
    },
  },
  1: {
    label: 'Docs Uploaded',
    styles: {
      backgroundColor: theme.palette.pinks.pink200,
      color: theme.palette.pinks.pink900,
    },
  },
  34: {
    label: 'Docs Received',
    styles: {
      backgroundColor: theme.palette.yellows.yellow200,
      color: theme.palette.yellows.yellow900,
    },
  },
  8: {
    label: 'Sales Pending',
    styles: {
      backgroundColor: theme.palette.blues.primaryBlue700,
      color: theme.palette.white.paper,
    },
  },
  9: {
    label: 'Credit Pending',
    styles: {
      backgroundColor: theme.palette.onlyTextTeal.main,
      color: theme.palette.white.paper,
    },
  },
  33: {
    label: 'Counter Offer',
    styles: {
      backgroundColor: theme.palette.blues.primaryBlue300,
      color: theme.palette.blues.primaryBlue900,
    },
  },
  2: {
    label: 'Rejected',
    styles: {
      backgroundColor: theme.palette.reds.red200,
      color: theme.palette.reds.red900,
    },
  },
  3: {
    label: 'Approved',
    styles: {
      backgroundColor: theme.palette.greens.codingGreen200,
      color: theme.palette.greens.codingGreen900,
    },
  },
  4: {
    label: 'instapayment',
    styles: {
      backgroundColor: theme.palette.blues.babyBlue200,
      color: theme.palette.blues.babyBlue900,
    },
  },
  5: {
    label: 'Customer Paid',
    styles: {
      backgroundColor: theme.palette.limes.lime200,
      color: theme.palette.limes.lime900,
    },
  },
  6: {
    label: 'Buy the Car',
    styles: {
      backgroundColor: theme.palette.teals.teal200,
      color: theme.palette.teals.teal900,
    },
  },
};

export const BOOKINGS_STAGES_ORDER = [
  27, 28, 0, 29, 30, 31, 32, 1, 34, 8, 9, 33, 2, 3, 4, 5, 6,
];

const commonBookingLabelStyles = {
  fontSize: '0.75rem',
  height: '15px',
};

export const BOOKING_LABELS_STYLED = BOOKING_LABELS.map(
  ({ value, styles }) => ({
    key: value,
    label: value,
    text: value,
    value,
    styles: {
      ...styles,
      ...commonBookingLabelStyles,
    },
  })
);

export const BOOKING_HISTORY_TABS = [
  {
    key: 'comment',
    label: 'Comments',
  },
  {
    key: 'email',
    label: 'Emails',
  },
  {
    key: 'sms',
    label: 'SMS',
  },
  {
    key: 'changelog',
    label: 'Changelog',
  },
];

export const ALLOWED_LABELS_CONFIGURATION_ROLES = [
  AGENT_ROLES.isAdmin,
  AGENT_ROLES.isSalesTeamLead,
  AGENT_ROLES.isCustomerSuccessTeamLead,
  AGENT_ROLES.isCustomerSuccessManager,
];

export const originOptions = [
  {
    text: 'HQ',
    value: 'hq',
  },
  {
    text: 'FORM',
    value: 'form',
  },
  {
    text: 'Contact form',
    value: 'contact-form',
  },
  {
    text: 'instaride:form',
    value: 'instaride:form',
  },
  {
    text: 'instaride',
    value: 'instaride',
  },
  {
    text: 'instatrade:form',
    value: 'instatrade:form',
  },
];

export const contractTypeOptions = [
  {
    text: 'Open',
    value: CONTRACT_TYPES.open,
  },
  {
    text: 'Fixed',
    value: CONTRACT_TYPES.fixed,
  },
];

export const contractPeriodOptions = [
  {
    text: '12 Μήνες',
    value: 12,
  },
  {
    text: '24 Μήνες',
    value: 24,
  },
  {
    text: '36 Μήνες',
    value: 36,
  },
  {
    text: '48 Μήνες',
    value: 48,
  },
];

export const stages = Object.keys(BOOKINGS_STAGES).reduce((acc, cur) => {
  acc.push({
    value: cur,
    text: BOOKINGS_STAGES[cur].label,
  });
  return acc;
}, []);

export const WON_TIME_EDIT_ROLES = [
  AGENT_ROLES.isAdmin,
  AGENT_ROLES.isSeniorSalesConsultant,
  AGENT_ROLES.isSalesTeamLead,
];

export const scrollableSectionHeightWithCardInfo = (additionalHeight) => ({
  [theme.breakpoints.up('lg')]: {
    overflow: 'auto',
    height: `calc(100vh - 220px - ${additionalHeight}px)`,
  },
});

export const BOOKING_STATUS = {
  open: 'open',
  lost: 'lost',
};

export const BOOKING_RULES_TYPES = {
  customerTypesStateChange: 'customerTypesStateChange',
  carIdChange: 'carIdChange',
  promisedDeliveryDateChange: 'promisedDeliveryDateChange',
};
